import React from 'react';
import { Container, Typography, Box, IconButton, Paper, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ConstructionIcon from '@mui/icons-material/Construction';

const AdminPromotions: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
      <Box className="page-header">
        <Box className="title-row" sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton onClick={() => navigate('/admin')} aria-label="back to admin">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" component="h1" className="page-title">Promotions & Coupons</Typography>
        </Box>
      </Box>

      <Alert severity="info" sx={{ mb: 3 }}>
        This feature is under development.
      </Alert>

      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, mb: 3 }}>
          <LocalOfferIcon sx={{ fontSize: 48, color: 'primary.main' }} />
          <ConstructionIcon sx={{ fontSize: 32, color: 'warning.main' }} />
        </Box>
        <Typography variant="h6" gutterBottom>
          Promotions Manager Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          The Promotions Manager will allow you to create and manage:
        </Typography>
        <Box component="ul" sx={{ textAlign: 'left', maxWidth: 400, mx: 'auto', color: 'text.secondary' }}>
          <li>Discount codes and coupons</li>
          <li>Limited-time promotions</li>
          <li>Referral programs</li>
          <li>Seasonal campaigns</li>
          <li>Loyalty rewards</li>
          <li>Special offers and bundles</li>
        </Box>
      </Paper>
    </Container>
  );
};

export default AdminPromotions;
